import { Component, OnInit } from '@angular/core';
import { DataService, Command } from '../shared/dataService';
import { Router } from '@angular/router'; 

import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  loginRequired: boolean; 
  fileUrl;
  private settings: Command[] = 
    [
        {
        id: "1",
        name: "Settings",
        items: 
        [
            {
            id: "1_1",
            name: "Zona Horaria",
            command :"timeZone"
            },
            
        ]
        }
        
    ];
  public pushLicense: any;
    
  constructor(private data:DataService, private router:Router,private sanitizer: DomSanitizer) 
  {
    console.log("Constructor Header Component");
    this.onGetPushLicense();
  }

  ngOnInit() : void
  {

    if (this.data.loginRequired) 
    {
      this.loginRequired=false;
      this.router.navigate(["/account"]);
      
    }
    else
    {
      this.loginRequired=true;
     // this.router.navigate(["/"]);
    } 
   
  }

  onGetPushLicense = function()
  {
    //getPushLicense
    this.data.getPushLicense().subscribe(success=>
    {
      if(success)
      {
        console.log("Licencia de la máquina obtenida");
        this.pushLicense = this.data.pushLicense; 
        const blob = new Blob([JSON.stringify(this.pushLicense) ], { type: 'application/octet-stream' });
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      }
    });
  }
 
  onLogOut()
  { 
    this.loginRequired=false;
    this.data.logOut();
    this.router.navigate(['/account']);
  }
}
